import React from 'react';

import {useCardText} from '../../../api/hooks/useCardText.hook';
import {BasicCardVariants} from '../../../utils/_enums/basic-card-variants.enum';
import {TypographyVariantsEnum} from '../../../utils/_enums/typeography-variants.enum';
import TeaserCardFooter from '../teaser-card-components/teaser-card-footer/teaser-card-footer';
import TeaserCardText from '../teaser-card-components/teaser-card-text/teaser-card-text';
import {Typography} from '../typography/typography';
import styles from './variant-card.module.scss';

export interface VariantCardProps {
    variantId: number;
    text: {
        headline: string;
        topline: string;
        description?: string;
        copies?: number;
        readMore?: () => void;
    },
    footer?: {
        salesFutureDate?: string;
        onPrimaryAction?: () => void;
        actionType: 'INFORMATION' | 'INFORMATION_AND_BUY';
    };
    type: BasicCardVariants;
    redirectUrl?: string;
    inverted?: boolean;
}

const VariantCard = (props: VariantCardProps): JSX.Element => {
    const data = useCardText();

    return (
        <div className={`${styles['variant-card-wrapper']} ${styles[`${props.type ? props.type : ''}`]}`}>

            {/* Optional text under the big image - right aligned */}
            {props.text.copies && props.text.copies > 0
                ? <div className={styles['optional-info']}>
                    <Typography
                        variant={TypographyVariantsEnum.TOPLINE_OR_LABEL}
                        inverted={props.inverted}
                    >{
                        `${props.text.copies} ${props.text.copies === 1 ? data?.copy : data?.copies}`}
                    </Typography>
                </div>
                : null
            }

            <div className={styles['teaser-card-text']}>
                {/* topline (Author name...), headline, description */}
                <TeaserCardText
                    {...props.text}
                    variant={props.type}
                    inverted={props.inverted}
                    redirectUrl={props.redirectUrl}
                />
            </div>

            {props.footer &&
                <TeaserCardFooter
                    {...props.footer}
                    inverted={props.inverted}
                    type={props.type}
                    redirectUrl={props.redirectUrl}
                    onInformation={props.footer.onPrimaryAction
                    && props.footer.actionType === 'INFORMATION'
                        ? props.footer.onPrimaryAction
                        : undefined}
                    onMoreInfoAndBuy={props.footer.onPrimaryAction
                    && props.footer.actionType === 'INFORMATION_AND_BUY'
                        ? props.footer.onPrimaryAction
                        : undefined}
                />
            }

        </div>
    );
};

export default VariantCard;
